import React from 'react';
import PropTypes from 'prop-types';
import MuiLink from '@material-ui/core/Link';
import { FormattedMessage, useIntl } from 'react-intl';

const booking = (intl) => {
  return (
    <MuiLink
      href={intl.formatMessage({ id: 'link.bookingterms', defaultMessage: '/en/terms-booking' })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage id="booking terms" defaultMessage="Booking Terms" />
    </MuiLink>
  );
};

const payment = (intl) => {
  return (
    <MuiLink
      href={intl.formatMessage({
        id: 'link.mangopayterms',
        defaultMessage: 'https://mangopay.com/terms-and-conditions/payment-services',
      })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage id="Payment Terms" defaultMessage="Payment Terms" />
    </MuiLink>
  );
};

const service = (intl) => {
  return (
    <MuiLink
      href={intl.formatMessage({ id: 'link.terms', defaultMessage: '/en/terms' })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage id="Terms of Service" defaultMessage="Terms of Service" />
    </MuiLink>
  );
};

const rental = (intl) => {
  return (
    <MuiLink
      href={intl.formatMessage({ id: 'link.generalterms', defaultMessage: '/en/terms-letting' })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage id="Rental Terms" defaultMessage="Rental Terms" />
    </MuiLink>
  );
};

const insurance = (intl) => {
  return (
    <MuiLink
      href={intl.formatMessage({
        id: 'link.omocomterms',
        defaultMessage: 'https://www.omocom.insurance/Stugknuten/Terms/SE/SV',
      })}
      target="_blank"
      rel="noreferrer"
    >
      <FormattedMessage id="Insurance Terms" defaultMessage="Insurance Terms" />
    </MuiLink>
  );
};

const AcceptTerms = ({ withRentalTerms }) => {
  const intl = useIntl();

  if (withRentalTerms) {
    return (
      <FormattedMessage
        id="acceptTermsRental"
        defaultMessage="I accept the {rental}, {service}, {booking} and {payment}."
        values={{
          service: service(intl),
          rental: rental(intl),
          booking: booking(intl),
          payment: payment(intl),
        }}
      />
    );
  }

  return (
    <FormattedMessage
      id="acceptTerms"
      defaultMessage="I accept the {service}, {booking} and {payment}."
      values={{
        booking: booking(intl),
        service: service(intl),
        payment: payment(intl),
      }}
    />
  );
};

const AcceptTermsWithInsurance = () => {
  const intl = useIntl();

  return (
    <FormattedMessage
      id="acceptTermsRentalInsurance"
      defaultMessage="I accept the {service}, {booking}, {payment}, {rental} and {insurance}."
      values={{
        service: service(intl),
        rental: rental(intl),
        booking: booking(intl),
        insurance: insurance(intl),
        payment: payment(intl),
      }}
    />
  );
};

AcceptTerms.propTypes = {
  withRentalTerms: PropTypes.bool,
};

export default AcceptTerms;
export { AcceptTermsWithInsurance, insurance };
